import React, { useEffect } from "react";
import MenuBar from "../components/common/MenuBar";
import { useNavigate } from "react-router-dom";
import HeadCont from "../components/common/HeadCont";

const Setting = () => {
    const navigate = useNavigate();

  // Scroll to top on page load
  useEffect(() => {
    // Try multiple approaches to ensure scroll works
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Also try after a slight delay to ensure it works after render
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 100);
  }, []);
  const datas = [
    // { id: 1, subMenu: [{ id: 1, title: '계정 설정', sublink: 'account' }, { id: 2, title: '알림 설정', sublink: 'push' }, { id: 3, title: '병원 회원 등록', sublink: 'hospital/register' }] },
    {
      id: 1,
      subMenu: [
        { id: 1, title: "Account Settings", sublink: "account" },
        { id: 2, title: "Notification Settings", sublink: "push" },
      ],
    },
    {
      id: 2,
      subMenu: [
        { id: 1, title: "Terms & Policy", sublink: "policy" },
        { id: 2, title: "Sources", sublink: "source" },
        { id: 3, title: "Version", sublink: "version" },
      ],
    },
  ];

  const navSublink = (link) => {
    navigate(`/${link}`);
  };
  return (
    <>
      <HeadCont transparent="white" title={"Settings"} />
      <section className="safe-area-mt-header">
        {datas.map((data) => (
          <div key={data.id} className="p-4 border-b border-gray_40">
            <ul>
              {data.subMenu.map((menu) => (
                <li
                  key={menu.id}
                  className={
                    "flex justify-between rounded-md p-3 cursor-pointer"
                  }
                  onClick={() => {
                    navSublink(menu.sublink);
                  }}
                  style={{
                    WebkitTapHighlightColor: 'transparent',
                    userSelect: 'none',
                    WebkitUserSelect: 'none',
                    position: 'relative',
                    zIndex: 1,
                    touchAction: 'manipulation'
                  }}
                >
                  <h2 className="text-body3_700 text-gray_180" style={{ pointerEvents: 'none', userSelect: 'none' }}>{menu.title}</h2>
                  <img
                    src="/images/mobile/icon/right.svg"
                    alt={"More icon"}
                    style={{ pointerEvents: 'none', userSelect: 'none' }}
                  />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </section>
      <MenuBar />
    </>
  );
};

export default Setting;
